import dynamic from 'next/dynamic'

export const BentoTwo = dynamic(() => import('./bento-two'), { ssr: false })
